import React from 'react';
import { Container, Box, Grid, Typography, Button } from '@mui/material';
import { keyframes } from '@emotion/react';
import { useNavigate } from 'react-router-dom';

const float = keyframes`
  0%, 100% {
    transform: translateY(0px);
  }
  50% {
    transform: translateY(-10px);
  }
`;

const HeroSection = () => {
    const navigate = useNavigate();

    const handleStartTest = () => {
        navigate('/zmiana-pracy');
    };

    return (
        <Box sx={{
            position: 'relative',
            minHeight: '90vh',
            display: 'flex',
            alignItems: 'center',
            overflow: 'hidden',
            background: 'linear-gradient(135deg, #f0f9ff 0%, #e0f2fe 50%, #f0fdfa 100%)',
            backgroundImage: 'url(/assets/Hero.jpg)',
            backgroundSize: 'cover',
            backgroundPosition: 'center',
            backgroundRepeat: 'no-repeat',
            '&::before': {
                content: '""',
                position: 'absolute',
                top: 0,
                left: 0,
                right: 0,
                bottom: 0,
                backgroundColor: 'rgba(255, 255, 255, 0.7)',
                zIndex: 1
            }
        }}>
            {/* Background blobs */}
            <Box sx={{
                position: 'absolute',
                top: '-50px',
                left: '-50px',
                width: '300px',
                height: '300px',
                borderRadius: '50%',
                background: 'linear-gradient(135deg, rgba(199, 154, 95, 0.1), rgba(155, 123, 94, 0.1))',
                filter: 'blur(40px)',
                animation: `${float} 6s ease-in-out infinite`
            }} />
            <Box sx={{
                position: 'absolute',
                bottom: '-100px',
                right: '-100px',
                width: '400px',
                height: '400px',
                borderRadius: '50%',
                background: 'linear-gradient(135deg, rgba(47, 62, 48, 0.1), rgba(199, 154, 95, 0.1))',
                filter: 'blur(50px)',
                animation: `${float} 8s ease-in-out infinite reverse`
            }} />

            <Container maxWidth="lg" sx={{ position: 'relative', zIndex: 2 }}>
                <Grid container spacing={4} alignItems="center">
                    <Grid item xs={12} md={8}>
                        <Typography
                            variant="h2"
                            sx={{
                                fontWeight: 'bold',
                                color: 'grey.800',
                                mb: 3,
                                fontSize: { xs: '2rem', md: '3.5rem' }
                            }}
                        >
                            FIND SOLUTION - spersonalizowane wsparcie w Twoich trudnościach
                        </Typography>
                        <Typography
                            variant="h6"
                            sx={{
                                color: 'grey.600',
                                mb: 4,
                                lineHeight: 1.6,
                                maxWidth: '700px'
                            }}
                        >
                            Wsparcie w trudnościach bez czekania. Find solution to platforma, która razem z Tobą zadba o Twój dobrostan psychiczny  i stworzy Twój spersonalizowany plan działania - Pakiet Mocy, pomagając Ci aktywnie realizować cele.
                        </Typography>
                        <Button
                            onClick={handleStartTest}
                            size="large"
                            sx={{
                                background: 'linear-gradient(90deg, #c79a5f, #9b7b5e)',
                                color: 'white',
                                px: 4,
                                py: 2,
                                fontSize: '1.1rem',
                                fontWeight: 'bold',
                                borderRadius: 3,
                                '&:hover': {
                                    transform: 'scale(1.05)',
                                    boxShadow: '0 12px 35px rgba(199, 154, 95, 0.4)'
                                },
                                transition: 'all 0.3s ease'
                            }}
                        >
                            Zbuduj swój plan działania
                        </Button>
                    </Grid>
                </Grid>
            </Container>
        </Box>
    );
};

export default HeroSection;
